import { header, getLanguage } from "./header";

const landing = header('restapi/api/v1/');

const getAuth = () =>{
    let authorization = localStorage.getItem('auth')
    landing.defaults.headers.common['Authorization'] =`Bearer ${authorization}` 
}

const setLanguage = () => {
    landing.defaults.headers.common['Accept-Language'] = getLanguage()
}

export const LandingService = {
    sendMessage(clientName, phoneNumber, requestType, message, industry, email){
        //setLanguage();
        //getAuth();
        
        const params = {clientName, phoneNumber, requestType, industry};

        if(requestType === 'CALL_TO_ACTION'){
            params.question = message;
        }
        else{
            params.keyword = message;
        }
        if(email && email !== ''){
            params.email = email;
        }

        return landing.post('/landings', {...params}).then(response => {
            return response.data
        })
    },
    getAllMessages(pageIndex=0, pageSize=100, sort="CREATED_AT", direction="DESC"){
        setLanguage();
        getAuth();
        return landing.get(`/landings?pageIndex=${pageIndex}&pageSize=${pageSize}`).then(response => {
            return response.data
        })
    }
}